import { StorageService } from '@xq/infrastructure';

export class GetStorageDownloadLinkUseCase {
  static async execute(path: string) {
    const storageService = StorageService.getInstance();

    return storageService.getDownloadLink(path);
  }
}
